import { useEffect, useState } from "react";
import { addCse, fetchRawThematics } from "../../HTTP/thematics";
import { countries } from "../../global/countriesAndSources";

export default function AddCse() {

  const localUser = JSON.parse(localStorage.getItem("user"))
    if (!localUser.super_admin && localUser.admin_access !== 4) {
        window.location.href = '/'
    }

    const [thematics, setThematics] = useState([])
    const [formData, setFormData] = useState({
        thematic_id: 0,
        country_code: '',
        cse : '',
        search_in_cse: false
    });
    
    // États pour la recherche de pays
    const [countrySearch, setCountrySearch] = useState('');
    const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
    const [filteredCountries, setFilteredCountries] = useState(countries);
    
    useEffect(() => {
        const fetchThematics = async () => {
            const res = await fetchRawThematics()
            setThematics(res)
        }
        fetchThematics()
    }, [])

    // Filtrer les pays en fonction de la recherche
    useEffect(() => {
        if (countrySearch.trim() === '') {
            setFilteredCountries(countries);
        } else {
            const filtered = countries.filter(country =>
                country.name.toLowerCase().includes(countrySearch.toLowerCase()) ||
                country.code.toLowerCase().includes(countrySearch.toLowerCase())
            );
            setFilteredCountries(filtered);
        }
    }, [countrySearch]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value
        }));
        console.log(formData)
    };

    const handleCountrySearchChange = (e) => {
        setCountrySearch(e.target.value);
        setIsCountryDropdownOpen(true);
    }

    const handleCountrySelect = (countryCode, countryName) => {
        setFormData(prevData => ({
            ...prevData,
            country_code: countryCode
        }));
        setCountrySearch(countryName);
        setIsCountryDropdownOpen(false);
    }

    const handleCountryInputFocus = () => {
        setIsCountryDropdownOpen(true);
    }

    const handleCountryInputBlur = () => {
        // Délai pour permettre le clic sur une option
        setTimeout(() => {
            setIsCountryDropdownOpen(false);
        }, 200);
    }

    // Obtenir le nom du pays sélectionné
    const getSelectedCountryName = () => {
        if (formData.country_code === 'wd') return 'Tous les pays';
        const selectedCountry = countries.find(country => country.code === formData.country_code);
        return selectedCountry ? selectedCountry.name : '';
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const request = {
            thematic_id: parseInt(formData.thematic_id),
            country_code: formData.country_code,
            cse: formData.cse,
            search_in_cse: formData.search_in_cse
        };
        console.log(request)
        try {
            const res = await addCse(request)
            if (res) {
                alert("CSE added successfully");
                window.location.href = "/admin/cse";
            }
            else {
                alert("An error occurred while adding the CSE");
            }
        } catch (error) {
            console.error("Error while adding CSE:", error);
            alert("Error while adding CSE")
        }
    }

    return (
        <div className="max-w-md mx-auto mt-8 p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-6 text-center">Ajouter un CSE</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label htmlFor="thematic_id" className="block text-gray-700 text-sm font-bold mb-2">
                        Thématique
                    </label>
                    <select
                        name="thematic_id"
                        id="thematic_id"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        required
                    >
                        <option value="">Sélectionner une thématique</option>
                        {thematics.map((thematic) => (
                            <option key={thematic.id} value={thematic.id}>
                                {thematic.path || thematic.name}
                            </option>
                        ))}
                    </select>
                </div>
                
                <div className="mb-4 relative">
                    <label htmlFor="country_code" className="block text-gray-700 text-sm font-bold mb-2">
                        Code pays
                    </label>
                    <input
                        type="text"
                        placeholder="Rechercher un pays..."
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={countrySearch}
                        onChange={handleCountrySearchChange}
                        onFocus={handleCountryInputFocus}
                        onBlur={handleCountryInputBlur}
                    />
                    
                    {isCountryDropdownOpen && (
                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
                            <div
                                className="px-3 py-2 hover:bg-blue-50 cursor-pointer border-b"
                                onClick={() => handleCountrySelect('wd', 'Tous les pays')}
                            >
                                <div className="font-medium">Tous les pays</div>
                            </div>
                            {filteredCountries.map((country) => (
                                <div
                                    key={country.code}
                                    className="px-3 py-2 hover:bg-blue-50 cursor-pointer"
                                    onClick={() => handleCountrySelect(country.code, country.name)}
                                >
                                    <div className="font-medium">{country.name}</div>
                                </div>
                            ))}
                            {filteredCountries.length === 0 && (
                                <div className="px-3 py-2 text-gray-500 text-center">
                                    Aucun pays trouvé
                                </div>
                            )}
                        </div>
                    )}
                    
                    {/* Champ caché pour la validation du formulaire */}
                    <input
                        type="hidden"
                        name="country_code"
                        value={formData.country_code}
                        required
                    />
                    
                    {/* Affichage du pays sélectionné */}
                    {formData.country_code && (
                        <div className="mt-2 text-sm text-gray-600">
                            Sélectionné: {getSelectedCountryName()} ({formData.country_code})
                        </div>
                    )}
                </div>
                
                <div className="mb-4">
                    <label htmlFor="cse" className="block text-gray-700 text-sm font-bold mb-2">
                        CSE
                    </label>
                    <input
                        type="text"
                        name="cse"
                        id="cse"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="mb-4">
                    <label htmlFor="search_in_cse" className="flex items-center">
                        <input
                            type="checkbox"
                            name="search_in_cse"
                            id="search_in_cse"
                            className="mr-2 leading-tight"
                            onChange={handleChange}
                        />
                        <span className="text-sm text-gray-700">
                            {
                                formData.search_in_cse
                                    ? "Les recherches seront réalisées dans le CSE (décochez pour rechercher dans les liens thématiques)"
                                    : "Les recherches seront réalisées dans les liens thématiques (cochez pour rechercher dans le CSE)"
                            }
                        </span>
                    </label>
                </div>
                <div className="flex items-center justify-end">
                    <button
                        type="submit"
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    );

}